import { Heading05 } from 'module/ui/components/styles';
import styled from 'styled-components';

export const Label = styled.span`
  ${Heading05};
  font-weight: var(--font-weight-semi-bold);
  font-size: var(--font-size-lg);
  margin: var(--spacing-05) var(--spacing-05) var(--spacing-04)
    var(--spacing-05);
`;

export const CitationDataPopoverContainer = styled.div`
  border-radius: 8px;
  overflow-y: scroll;
  width: 324px;
  max-height: 326px;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);
`;

export const StyledLoader = styled(CitationDataPopoverContainer)`
  align-items: center;
  justify-content: center;
  margin: var(--spacing-05);
`;

export const SummaryContainer = styled.div<{ $hasMarginTop?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);
  margin: ${({ $hasMarginTop }) =>
    $hasMarginTop
      ? 'var(--spacing-04) var(--spacing-05) 0 var(--spacing-05)'
      : '0 var(--spacing-05) 0 var(--spacing-05)'};
`;

export const SummaryLabel = styled.div`
  font-weight: var(--font-weight-semi-bold);
  font-size: var(--font-size-md);
  color: var(--text-secondary);
`;

export const SummaryText = styled.div`
  font-size: var(--font-size-md);
  color: var(--text-primary);
  line-height: 1.5;
`;

export const CitationDataWrapper = styled.div<{ $hasGreyBackground?: boolean }>`
  background-color: ${({ $hasGreyBackground }) =>
    $hasGreyBackground ? 'var(--scarlet-gray-30)' : 'transparent'};
  padding-top: ${({ $hasGreyBackground }) =>
    $hasGreyBackground ? 'var(--spacing-05)' : '0'};
`;
